import React from "react";
import "./style.css";

function Card({imgLink, text}) {
  return (
    <div className="card max-w-sm p-5">
      <div className="flex items-center justify-between mb-5">
        <img className="h-14 w-14" src={imgLink} alt="a"/>
        <div className="text-center text-white font-bold text-2xl">{text}</div>
      </div>
      <div>
        <h4 className="mb-2 text-zinc-400"><span className="font-medium text-white">user</span>  100 Min + Monthly Activ Users</h4>
        <h4 className="mb-2 text-zinc-400"><span className="font-medium text-white">tag</span>Rs. 30.000 Min Spend</h4>
      </div>
    </div>
  );
}

export default Card;
